import { IStatusIcon } from '@app/shared/interfaces/common-interfaces';
import { iconCodes } from '@app/shared/cqes-icon/cqes-icon.component';

export enum DeviceStatus {
    ACTIVE = 'ACTIVE',
    BLOCKED = 'BLOCKED',
    DELETED = 'DELETED',
    NEW = 'NEW',
    WAITING = 'WAITING',
}

export const statusIcon = {
    ACTIVE: {
        icon: iconCodes.done,
        colorClass: 'text-success',
        tooltip: 'deviceTexts.tooltips.statusActive'
    } as IStatusIcon,
    BLOCKED: {
        icon: iconCodes.pan_tool,
        colorClass: 'text-warning',
        tooltip: 'deviceTexts.tooltips.statusBlocked'
    } as IStatusIcon,
    DELETED: {
        icon: iconCodes.delete,
        colorClass: 'text-danger',
        tooltip: 'deviceTexts.tooltips.delete'
    } as IStatusIcon,
    NEW: {
        icon: iconCodes.fiber_new,
        colorClass: 'text-success',
        tooltip: 'deviceTexts.tooltips.statusNew'
    } as IStatusIcon,
    WAITING: {
        icon: iconCodes.hourglass_empty,
        colorClass: 'text-warning',
        tooltip: 'deviceTexts.tooltips.statusWaiting'
    } as IStatusIcon,
};

export interface IMobileDevice {
    name: string;
    appId: string;
    registrationDate: string;
    lastUpdateDate: string;
    status: DeviceStatus;
    certificateReqIds: string[];
}
